import { reactive, onMounted, inject, provide, watch } from "vue"

import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign";

export function useCampaignListHostComposable(listConfig, filterConfig) {
    const states = reactive({
        listConfig: listConfig,
        filterConfig: filterConfig,
    })

    provide("listConfig", states.listConfig)
    provide("filterConfig", states.filterConfig)

    return { states }
}

export default function useCampaignListComposable(opts = {}, emit) {

    const states = reactive({
        campaigns: [],
        isLoading: false,
        isLoaded: false,
        isHaveItem: false
    })

    const listConfig = inject('listConfig')
    const filterConfig = inject('filterConfig')

    const getList = function () {
        return new Promise((resolve, reject) => {
            states.isLoading = true;
            BzbsCampaign.apiGetCampaign(listConfig.create(), filterConfig.create()).subscribe({
                next: (campaigns) => {
                    listConfig.intSkip += listConfig.defaultTopAmount;
                    //check is there are more campaign.
                    if (campaigns && campaigns.length < listConfig.defaultTopAmount) {
                        listConfig.isSeeMoreEnable = false;
                    }

                    //reinitialize list if no skip.
                    if (listConfig.intSkip == listConfig.defaultTopAmount) {
                        states.campaigns = [];
                    }

                    for (var campaign of campaigns) {
                        states.campaigns.push(campaign);
                    }


                    states.isLoading = false;
                    states.isHaveItem = states.campaigns.length > 0
                        ? true
                        : false;
                    states.isLoaded = true;
                    emit('onLoaded', states);

                    resolve();
                },
                error: (err) => {
                    states.isLoading = false;
                    states.isLoaded = true;
                    states.isHaveItem = false;
                    emit('onError', err)

                    reject();
                }
            });
        });
    }

    const loadMore = function () {
        console.log('load more list', listConfig.isSeeMoreEnable);
        if (!listConfig.isSeeMoreEnable || states.isLoading) {
            return;
        }
        states.getList();
    }

    watch(() => states.isLoading, (val) => {
        emit("onLoadingChange", val)
    })

    if (opts.getOnMounted != undefined) {
        onMounted(getList)
    }

    return {
        states,
        getList,
        loadMore
    }
}
